import React, { useEffect, useState } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import { del } from "../../../../helpers/api_helper";
import AddNewMasterPlanet from "./Modal/AddNewMasterPlanet";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";

const TableData = ({ masterPlanet, setRefresh }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedMasterPlanet, setSelectedMasterPlanet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [planetToDelete, setPlanetToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("masterPlanet", "UPDATE");
  const hasDeletePermission = useCheckPermission("masterPlanet", "DELETE");

  useEffect(() => {
    if (masterPlanet && masterPlanet.length > 0) {
      setLoading(false);
    }
  }, [masterPlanet]);

  const handleDelete = async () => {
    try {
      const response = await del(`/planet/${planetToDelete}`);
      if (response.success) {
        setRefresh(true);
        toast.success("Master planet deleted successfully");
      } else {
        console.log(response.message);
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowConfirm(false);
    }
  };

  const confirmDelete = (id) => {
    setPlanetToDelete(id);
    setShowConfirm(true);
  };

  const handleEdit = (data) => {
    setSelectedMasterPlanet(data);
    setModalMode("edit");
    setShowModal(true);
  };

  return (
    <>
      <AddNewMasterPlanet
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => setRefresh(true)}
        mode={modalMode}
        masterPlanetData={selectedMasterPlanet}
      />

      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">Master Planet</th>
              <th className="fw-normal border-0">Ticker Name</th>
              <th className="fw-normal border-0">Stock Exchange Name</th>
              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {masterPlanet && masterPlanet.length > 0 ? (
              masterPlanet?.map((data, key) => (
                <tr key={key}>
                  <td className="text-capitalize">
                    {data?.name ? data?.name : "-"}
                  </td>
                  <td>
                    {data?.stock?.ticker_name ? data?.stock?.ticker_name : "-"}
                  </td>

                  <td>
                    {data?.stock?.stock_name ? data?.stock?.stock_name : "-"}
                  </td>
                  <td>
                    <span className="labelTag greenLabel text-capitalize">
                      {data?.status ? data?.status : "-"}
                    </span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center gap-10">
                      {hasUpdatePermission && <Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => handleEdit(data)}
                      >
                        <img src={action_icon_1} alt="" />
                      </Button>}
                      {hasDeletePermission && < Button
                        className="border-0 p-0"
                        variant="transparent"
                        onClick={() => confirmDelete(data?._id)}
                      >
                        <img src={action_icon_2} alt="" />
                      </Button>}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No data available</td>
              </tr>
            )}
          </tbody>
        </Table >
      )}
    </>
  );
};

export default TableData;
